import { inject, Service } from '@angular/core';
import { BaseApi } from 'src/app/core/services/api/base.api';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ToastService } from '@app/core/services/toast.service';
import { DialogService } from '@app/core/services/dialog.service';

import { UUID } from '@app/_api/identifyable';

export type TreeFilterState = {
  onlyAssignments: boolean;
  tags: UUID[];
};

@Service()
export class TreeFilterApi extends BaseApi {
  constructor() {
    const http = inject(HttpClient);
    const toastService = inject(ToastService);
    const dialog = inject(DialogService);

    super(http, '/employee', toastService, dialog);
  }

  getTreeFilterState(): Observable<TreeFilterState> {
    return super.GET<TreeFilterState>('/tree-filter');
  }

  updateTreeFilterState(updatedState: TreeFilterState): Observable<void> {
    return super.PATCH<void>('/tree-filter', updatedState, undefined, {});
  }
}
